export { default } from './TaskExecLogItem';



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsLists/_items/TaskExecLogItem/index.js